import type { TaskCardDemoSocial } from '../TasksTaskCards/tasksTaskCards.constants'

function trimTrailingZeroOneDecimal(s: string): string {
  return s.replace(/\.0([KM])$/, '$1')
}

export function shouldShowTaskCardPlatformCornerBadge(
  brandLogoSrc: string | undefined,
  social: TaskCardDemoSocial
): boolean {
  if (social == null) {
    return false
  }
  if (brandLogoSrc == null || brandLogoSrc.length === 0) {
    return false
  }
  return (
    brandLogoSrc.startsWith('http://') || brandLogoSrc.startsWith('https://')
  )
}

export function formatParticipantCap(value: number): string {
  if (!Number.isFinite(value) || value <= 0) {
    return '0'
  }
  if (value >= 1_000_000) {
    const m = value / 1_000_000
    const raw = m >= 10 ? `${Math.round(m)}M` : `${m.toFixed(1)}M`
    return trimTrailingZeroOneDecimal(raw)
  }
  if (value >= 1000) {
    const k = value / 1000
    const raw = k >= 10 ? `${Math.round(k)}K` : `${k.toFixed(1)}K`
    return trimTrailingZeroOneDecimal(raw)
  }
  return String(Math.round(value))
}

export function participantLimitFillRatio(
  current: number,
  limit: number
): number {
  if (!Number.isFinite(current) || !Number.isFinite(limit) || limit <= 0) {
    return 0
  }
  return Math.min(100, Math.max(0, (current / limit) * 100))
}
